import React from 'react';

import { MainContainer } from 'components/Main';

export const App = (): JSX.Element => (
  <MainContainer />
);
